import React from "react";
import { useState, useEffect } from "react";
import { FaComputer } from "react-icons/fa6";
import { FaMobileScreenButton } from "react-icons/fa6";



const Servicios = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500); // 3000 milisegundos = 3 segundos

    // Limpiar el timer cuando el componente se desmonte
    return () => clearTimeout(timer);
  }, []);

  return (
    
    <div className={`bg-[#0c1428] text-white p-8 flex flex-col `}>
      <div
        className={`transition-transform duration-1000 ${
          isVisible
            ? "translate-x-0 opacity-100"
            : "-translate-x-full opacity-0"
        }`}
      >
        <div className="flex flex-col itmes-center justify-around mb-8 sm:flex-row">
          <div className="w-full mb-4 mr-4 text-3xl font-semibold sm:w-1/3 p-2">
            <h1>Nuestros Servicios</h1>
            <p>Desarrollo de software personalizado y atractivo</p>
          </div>

          <div className="w-[100%] mb-4 border border-[#007fba] rounded-lg p-4  mr-4 sm:w-1/3">
          <div className="flex justify-center ">
            <img
              className="w-[60px] h-[60px]"
              src="assets/webc.png"
              alt="logo.png"
            ></img> </div>
            <h1 className="text-center text-3xl mb-2 ">Desarrollo Web</h1>
            <p className="text-justify">
              Creación de sitios y aplicaciones web personalizados, optimizados
              para ofrecer una excelente experiencia de usuario, con diseño
              responsivo y funcionalidad adaptada a las necesidades del cliente
            </p>
          </div>

          <div className="w-[100%] mb-4 border border-[#007fba] rounded-lg p-4  mr-4 sm:w-1/3">
          <div className="flex justify-center "><img
              className="w-[60px] h-[60px]"
              src="assets/movilc.png"
              alt="logo.png"
            ></img> </div>
            <h1 className="text-center text-3xl mb-2 ">Desarrollo Movil</h1>
            <p className="text-justify">
              Aplicaciones móviles intuitivas y funcionales, diseñadas para
              ofrecer una experiencia de usuario fluida en dispositivos Android
              e iOS, adaptadas a las necesidades y objetivos específicos del
              cliente.
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-around sm:flex-row">
          <div className="w-[100%] mb-4 border border-[#007fba] rounded-lg p-4  mr-4 sm:w-1/3">
         <div className="flex justify-center "> <img
              className="w-[60px] h-[60px]"
              src="assets/softwarec.png"
              alt="logo.png"
            ></img> </div>
            <h1 className="text-center text-3xl mb-2 ">Desarrollo de Software</h1>
            <p className="text-justify">
              Ofrecemos soluciones personalizadas y a medida para automatizar
              procesos, mejorar la eficiencia operativa y satisfacer las
              necesidades específicas de cada cliente.
            </p>
          </div>

          <div className="w-[100%] mb-4 border border-[#007fba] rounded-lg p-4  mr-4 sm:w-1/3">
           <div className="flex justify-center "> <img className="w-[50px]" src="assets/diseñoc.png"></img> </div>
            
            <h1 className="text-center text-3xl mb-2 ">Diseño Gráfico</h1>
            <p className="text-justify">
              Creación de contenido visual atractivo y profesional, desde
              logotipos y branding hasta materiales promocionales y gráficos
              digitales, todo con el objetivo de comunicar eficazmente la
              identidad y mensaje de la marca del cliente.
            </p> 
          </div>

          <div className="w-[100%] mb-4 border border-[#007fba] rounded-lg p-4  mr-4 sm:w-1/3">
           <div className="flex justify-center "> <img className="w-[50px]" src="assets/icon-redes.svg"></img> </div>
            <h1 className="text-center text-3xl mb-2 ">Redes Sociales</h1>
            <p className="text-justify">
              Crear y ejecutar estrategias efectivas para aumentar la presencia
              online, interactuar con la audiencia y mejorar la visibilidad de
              la marca en plataformas clave, generando contenido relevante y
              gestionando la comunidad digital del cliente.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Servicios;
